import Vue from 'vue';
import axios from 'axios';

export default Vue.component('contract-overview', {
    data: () => ({
        axe: axios.create({
            baseURL: '/mywecycle/contract'
        }),
        importFile: null,
        templateFileUrl: null,
        loading: false
    }),
    methods: {
        openModal() {
            if (this.templateFileUrl) {
                window.$('#modal-contract-import').modal('show');
            } else {
                let response;
                this.axe.get("/GetImportTemplateFileUrl")
                .then((resp) => {
                    response = resp.data;
                    if (response.TemplateFileUrl !== "")
                        this.templateFileUrl = response.TemplateFileUrl;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    window.$('#modal-contract-import').modal('show');
                });
            }
        },
        downloadTemplate() {
            window.open(this.templateFileUrl);
        },
        uploadFile(event) {
            this.importFile = event.target.files[0];
        },
        importContracts() {
            this.loading = true;
            
            let formData = new FormData();
            formData.append('ImportContractsFile', this.importFile, this.importFile.name);
            
            let response;
            this.axe.post("/UploadContractsFile", formData)
                .then((resp) => {
                    response = resp.data;
                    One.helpers('notify', { type: response.notification.type, icon: response.notification.type == 'success' ? 'fa fa-check mr-1' : 'fa fa-exclamation-triangle mr-1', message: response.notification.content });
                    
                    // Close modal if successfull
                    if (!response.hasErrors) {
                        window.$('#modal-contract-import').modal('hide');
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    }
});